export enum DampingType {
    Linear = 0, // Linéaire
    Degressive = 1, // Dégressif
    Exceptional = 2 // Exceptionnel
}